import './LoginButtons.css';

const LogoComponent = () => {
    return (
        <div className='image-container'>
            <img src="https://taki-bucket-1-1-0.s3.ap-northeast-2.amazonaws.com/mainLogo.png" alt='Logo' />
            {/* <img src="https://taki-bucket-1-1-0.s3.ap-northeast-2.amazonaws.com/characther.png" alt='Logo' /> */}
        </div>
    );
};

export default LogoComponent;
